import { IndicatorPill } from "@codat/orchard-ui";
import React from "react";

const getStatusPillColour = (value: string) => {
  if (value.toLowerCase().includes("success")) {
    return "green";
  }

  if (value.toLowerCase().includes("failed")) {
    return "red";
  }

  if (value.toLowerCase().includes("partial")) {
    return "orange";
  }

  return "blue";
};

export const StatusPill: React.FC<{ value: string; className?: string }> = ({
  value,
  className,
}) => (
  <IndicatorPill
    label={value}
    color={getStatusPillColour(value)}
    className={className}
    data-testid="status-pill"
  />
);
